/* import __COLOCATED_TEMPLATE__ from './lsg-chip-seller-rating.hbs'; */
import Component from '@glimmer/component';
import clsx from 'clsx';


 export const LSG_CHIP_SELLER_RATING__STYLE = {
  PEOPLE_CENTER_VARIANT: 'LSG-chip-seller-rating--people-center',
  TOP_TALENT: 'LSG-chip-seller-rating--top-talent',
  NEW_SELLER: 'LSG-chip-seller-rating--new-seller'
};

class LsgChipSellerRating extends Component {

  get chipClasses() {
    return clsx(
      'LSG-chip-seller-rating',
      this.args.rating > 3 && LSG_CHIP_SELLER_RATING__STYLE.TOP_TALENT,
      this.args.rating < 4 && LSG_CHIP_SELLER_RATING__STYLE.NEW_SELLER,
      this.args.variant === 'people-center' && LSG_CHIP_SELLER_RATING__STYLE.PEOPLE_CENTER_VARIANT,
    );
  }

}

export default LsgChipSellerRating;
